import { record } from "@pomle/shapes";
import { boolean } from "./validators";

export type FeaturePreferences = {
  type: "feature_preferences/v1";
  roomScanWarningEnabled: boolean;
};

type FeaturePreferenceStorage = {
  roomScanWarningEnabled: boolean;
};

const defaultFeaturePreference: FeaturePreferences = {
  type: "feature_preferences/v1",
  roomScanWarningEnabled: false,
};

export const featurePreferenceStorageRecord = record<FeaturePreferenceStorage>({
  roomScanWarningEnabled: boolean(
    defaultFeaturePreference.roomScanWarningEnabled
  ),
});

export function createFeaturePreferences(
  preferences: FeaturePreferenceStorage | undefined
): FeaturePreferences {
  if (!preferences) {
    return { ...defaultFeaturePreference };
  }

  return {
    type: "feature_preferences/v1",
    ...preferences,
  };
}
